export default __webpack_public_path__ + "static/media/WebResume1.26ce847c.png";